import React from 'react';
const links = ['Termini e Condizioni', 'Privacy Policy', 'Contatti'];
export function Footer() {
  return <footer className="border-t border-ink-500 bg-ink-800 px-4 pb-28 pt-10 text-center sm:px-6" data-id="element-136" data-mp="208ce79corfro">
      <p className="font-display text-xl font-bold uppercase tracking-wide text-bone" data-id="element-137" data-mp="2f53ah9r2cbd2">
        Sistema Maestro di Saldatura™
      </p>
      <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2" data-id="element-138" data-mp="2a6ianbfq3tp5">
        {links.map(link => <li key={link} data-id="element-139" data-mp="1me1u55bmw9ry">
            <a href="#" className="text-[13px] font-semibold text-mute transition-colors duration-150 ease-out hover:text-arc-light" data-id="element-140" data-mp="1hhbegj3qrg72">
              {link}
            </a>
          </li>)}
      </ul>
      <p className="mt-5 text-[12px] leading-relaxed text-mute/80" data-id="element-141" data-mp="1reh89z3qplaz">
        © 2026 Sistema Maestro di Saldatura™ — Tutti i diritti riservati.
      </p>
    </footer>;
}